export const TABS_ITEMS_GROUP_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TabsItemsGroupWidgetElement';
